module.exports = __webpack_public_path__ + "img/login_pic@2x.cf75b74d.png";